import lo from 'lodash'
import sb from '@sb/util'

import AppendToBody from '../commons/append_to_body.js'

const WIDTH = 320
const HEIGHT = 250
const EDGE = 50

export default {
	name: 'due-date-picker',
	data() {
		return {
			isDropdownOpen: false,
			keyword: '',
		}
	},

	mounted() {},

	methods: {
		renderDropdown() {
			if (!this.isDropdownOpen) return null

			let style = {}
			if (this.style) style = lo.cloneDeep(this.style)

			return (
				<AppendToBody>
					<div style={style} vOn:click_stop={() => false} class='dropdown d-flex flex-column'>
						<div class='dropdown_filter_container'>
							<div class='dropdown_filter_input_container'>
								<input
									class='form-control dropdown_filter_input'
									style='padding-left: 5px; padding-right: 5px;'
									placeholder={this.$t('change_due_date')}
									vModel={this.keyword}
									ref='input'
								/>
							</div>
						</div>
						<div class='dropdown_item_cotainer'>{this.renderItems()}</div>
					</div>
				</AppendToBody>
			)
		},

		renderItems() {
			return (
				<Fragment>
					<div class='dropdown_item'>Lorem</div>
					<div class='dropdown_item'>Ipsum</div>
					<div class='dropdown_item'>Dolores</div>
				</Fragment>
			)
		},

		calculateCord() {
			let $wrapper = this.$refs.container
			let rect = $wrapper ? $wrapper.getBoundingClientRect() : {}
			let {top = 0, left = 0, width = 0, height = 0, right = 0} = rect

			let isBottom = document.body.offsetHeight - top < HEIGHT + EDGE
			let isRight = document.body.offsetWidth - left < WIDTH + EDGE

			let style = {
				zIndex: '99999',
				width: WIDTH + 'px',
				height: HEIGHT + 'px',
				maxWidth: 'unset',
				maxHeight: 'unset',
				minHeight: 'unset',
				minWidth: 'unset',
				position: 'absolute',
			}
			if (isRight) {
				style.right = document.body.offsetWidth - (width + left) + 'px'
			} else {
				style.left = left + 'px'
				style.right = 'unset'
			}
			if (isBottom) {
				style.bottom = document.body.offsetHeight - top + 'px'
				style.top = 'unset'
			} else {
				style.top = top + height + 'px'
			}

			this.style = style
		},

		async toggleDropdown() {
			this.isDropdownOpen = !this.isDropdownOpen
			if (this.isDropdownOpen) {
				this.calculateCord()
				await this.$nextTick()
				this.$refs.input && this.$refs.input.focus()
			}
		},

		closeDropdown() {
			this.isDropdownOpen = false
		},
	},

	render() {
		return (
			<div ref='container' v-clickaway={this.closeDropdown}>
				{this.renderDropdown()}
				<div vOn:click={this.toggleDropdown}>{this.$slots.default}</div>
			</div>
		)
	},
}
